import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000';

// Debug: Log the API URL (remove this after fixing)
console.log('🔍 API URL being used:', API_URL);
console.log('🔍 REACT_APP_API_URL env var:', process.env.REACT_APP_API_URL);

const api = axios.create({
  baseURL: API_URL,
  withCredentials: true, // Important for session cookies
});

export default api;

